"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var autoCapture_1 = __importDefault(require("./autoCapture"));
var statsig_js_1 = require("statsig-js");
var utils_1 = require("./utils");
var StatsigWA = /** @class */ (function () {
    function StatsigWA() {
    }
    StatsigWA.initialize = function (apiKey, autoStart, shouldAutoCapture) {
        var _a;
        if (shouldAutoCapture === void 0) { shouldAutoCapture = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (shouldAutoCapture) {
                            this._captureHelper = new autoCapture_1.default(autoStart);
                        }
                        this._statsigInstance = new statsig_js_1.StatsigClient(apiKey, (0, utils_1.getStatsigUser)());
                        return [4 /*yield*/, this._statsigInstance.initializeAsync()];
                    case 1:
                        _b.sent();
                        (_a = this._captureHelper) === null || _a === void 0 ? void 0 : _a.setStatsigInstance(this._statsigInstance);
                        if (window) {
                            window['statsig_wa'] = window['statsig_wa'] || this;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StatsigWA.start = function () {
        var _a;
        (_a = this._captureHelper) === null || _a === void 0 ? void 0 : _a.start();
    };
    StatsigWA.stop = function () {
        var _a;
        (_a = this._captureHelper) === null || _a === void 0 ? void 0 : _a.stop();
    };
    StatsigWA.getStatsigUser = function () {
        return (0, utils_1.getStatsigUser)();
    };
    StatsigWA.getStatsigClient = function () {
        return this._statsigInstance;
    };
    StatsigWA._captureHelper = null;
    StatsigWA._statsigInstance = null;
    return StatsigWA;
}());
exports.default = StatsigWA;
if (document.currentScript) {
    debugger;
    var srcUrl = document.currentScript.getAttribute('src');
    var baseUrl = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href;
    if (srcUrl && baseUrl) {
        try {
            var url = new URL(srcUrl, baseUrl);
            var apiKey = url.searchParams.get('apikey');
            var autoStart = url.searchParams.get('autostart') !== '0';
            var autoCapture = url.searchParams.get('autocapture') !== '0';
            if (apiKey) {
                StatsigWA.initialize(apiKey, autoStart, autoCapture);
            }
            else {
                console.error('Statsig Web AutoCapture: No API key provided');
            }
        }
        catch (e) {
            console.error('Statsig Web AutoCapture: Invalid source URL');
        }
    }
}
